import { Component } from 'react';
import { connect } from 'react-redux';
import getComponentName from 'react-utils/getComponentName';
import { attachWrappedComponent } from 'automation-ui-core/decoratorUtils';
import { getFlowRevision, getFlowRevisionRequestStatus } from 'automation-ui-canvas/selectors/flowSelectors';
import * as ReduxRequestStates from 'redux-request-state/requestStates';
import { compose } from 'redux';
import { wireFlowById } from 'automation-ui-canvas/queries/flowQueries';
import { jsx as _jsx } from "react/jsx-runtime";
export default function wireFlow(WrappedComponent) {
  class WiredFlowDecorator extends Component {
    render() {
      return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, this.props));
    }
  }
  WiredFlowDecorator.displayName = `WiredFlow(${getComponentName(WrappedComponent)})`;
  WiredFlowDecorator.defaultProps = WrappedComponent.defaultProps;
  attachWrappedComponent(WiredFlowDecorator, WrappedComponent);
  return compose(_WrappedComponent => props => {
    const {
      flowId: flowIdStr
    } = props.match.params;
    const flowId = Number(flowIdStr);
    return /*#__PURE__*/_jsx(_WrappedComponent, Object.assign({}, props, {
      flowId: flowId
    }));
  }, wireFlowById, connect((state, {
    match,
    flowId,
    flow: currentFlow,
    flowQuery
  }) => {
    const {
      revisionId: revisionIdStr
    } = match.params;
    const revisionId = Number(revisionIdStr);
    let flow;
    let flowStatus;
    if (revisionIdStr) {
      const flowRevision = getFlowRevision(flowId, revisionId)(state);
      flow = flowRevision && flowRevision.flow;
      flowStatus = getFlowRevisionRequestStatus(state);
    } else {
      flow = currentFlow;
      if (flowQuery.loading) {
        flowStatus = ReduxRequestStates.STARTED;
      } else if (flowQuery.error) {
        flowStatus = ReduxRequestStates.FAILED;
      } else {
        flowStatus = ReduxRequestStates.SUCCEEDED;
      }
    }
    return {
      flowId,
      flow,
      flowStatus
    };
  }))(WiredFlowDecorator);
}